import {
  Row,
  Col,
  Button,
  Dropdown,
  Select,
  Space,
  Radio,
  Calendar,
  DatePicker,
  Menu,
  Checkbox,
} from "antd";
import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Today.css";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import dayjs from "dayjs";
import Spinner from "../../common/Spinner";
import { FaAngleDown, FaCross, FaCrosshairs, FaXmark } from "react-icons/fa6";
import { LeftOutlined, RightOutlined, SearchOutlined } from "@ant-design/icons";
import {
  BASE_URL,
  FetchAttendanceTodayView,
  FetchDepartment,
  FetchDesignation,
  FetchLocation,
  FetchShifts,
} from "../../utils/constant";
import { useSelector } from "react-redux";
import AttachmentModal from "../../common/attachmentsModal";
import CalendarIcon from "../../assets/icons/calendar.svg";
import SearchIcon from "../../assets/icons/search.svg";
import { ExportToExcel } from "../../common/ExportToExcel";
import ImageModal from "../../common/ImageModal";
import { attachment, placeholder } from "../../utils/default";
const { Option } = Select;
function Today() {
  const gridRef = useRef([]);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const designationState = useSelector(
    (state) => state.designation.designation
  );
  const departmentState = useSelector((state) => state.department.department);
  const ShiftState = useSelector((state) => state.shift.shift);
  const locationState = useSelector((state) => state.location.location);
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  const [calendarVisible, setCalendarVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
  const [showSelectedDate, setshowSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [staffData, setStaffData] = useState(null);
  const [departments, setDepartments] = useState(departmentState);
  const [designations, setDesignations] = useState(designationState);
  const [shift, setShift] = useState(ShiftState);
  const [location, setLocation] = useState(locationState);

  const [departmentsSelected, setDepartmentsSelected] = useState();
  const [designationsSelected, setDesignationsSelected] = useState();
  const [shiftSelected, setShiftSelected] = useState();
  const [locationSelected, setLocationSelected] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const keys = departmentState
    .map((item, index) => (index === 0 || index === 1 ? item.key : null))
    .filter((key) => key !== null);

  const [selectedDepartment, setSelectedDepartment] = useState(keys);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedShift, setSelectedShift] = useState([]);
  const [openAttachmentModal, setOpenAttachmentModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [notes, setNotes] = useState();
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const [todaysExportData, setTodaysExportData] = useState([]);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState('');

  const showAttachmentModal = () => {
    setOpenAttachmentModal(true);
  };

  const attachmentsAndNotes = (attachments, notes) => {
    setAttachments(attachments);
    setNotes(notes);
    showAttachmentModal();
  };
  const handleOk = () => {
    setOpenAttachmentModal(false);
  };
  const handleCancel = () => {
    setOpenAttachmentModal(false);
  };
  var gridOptions = {
    rowHeight: 45,
  };
  const handleMenuClick = ({ key }) => {
    const updatedItems = [...selectedItems];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedItems(updatedItems);
  };

  const onFilterTextBoxChanged = useCallback((event) => {
    const filterValue = event.target.value;
    gridRef.current.forEach((grid, index) => {
      if (grid?.api) {
        grid?.api.setQuickFilter(filterValue);
      }
    });
  }, []);
  const toggleSearchVisibility = () => {
    setIsSearchVisible((prevState) => !prevState);
  };
  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item className="checktext" key="isStaffLessTime">
        <Checkbox
          className="mr-1"
          checked={selectedItems.includes("isStaffLessTime")}
        />
        Less Time
      </Menu.Item>
      <Menu.Item className="checktext" key="isAbsent">
        <Checkbox
          className="mr-1"
          checked={selectedItems.includes("isAbsent")}
        />
        Absent
      </Menu.Item>
      <Menu.Item className="checktext" key="isStaffHalfDay">
        <Checkbox
          className="mr-1"
          checked={selectedItems.includes("isStaffHalfDay")}
        />
        Half Day
      </Menu.Item>
      <Menu.Item className="checktext" key="isWrongLocation">
        <Checkbox
          className="mr-1"
          checked={selectedItems.includes("isWrongLocation")}
        />
        Wrong Location
      </Menu.Item>
    </Menu>
  );

  const handleDesigMenuClick = ({ key }) => {
    const updatedItems = [...selectedDesignation];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedDesignation(updatedItems);
  };
  const handleShiftMenuClick = ({ key }) => {
    const updatedItems = [...selectedShift];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedShift(updatedItems);
  };
  const handleLocationMenuClick = ({ key }) => {
    const updatedItems = [...selectedLocation];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedLocation(updatedItems);
  };
  const handleDeptMenuClick = ({ key }) => {
    const updatedItems = [...selectedDepartment];
    const index = updatedItems.indexOf(key);
    if (index === -1) {
      updatedItems.push(key);
    } else {
      updatedItems.splice(index, 1);
    }
    setSelectedDepartment(updatedItems);
  };
  const dept = (
    <Menu onClick={handleDeptMenuClick}>
      {departments?.map((department) => (
        <Menu.Item className="checktext" key={department.key}>
          <Checkbox
            className="mr-1"
            checked={selectedDepartment.includes(department.key)}
          />
          {department.value}
        </Menu.Item>
      ))}
    </Menu>
  );
  const desigMenu = (
    <Menu onClick={handleDesigMenuClick}>
      {designations.map((designation) => (
        <Menu.Item className="checktext" key={designation.key}>
          <Checkbox
            className="mr-1"
            checked={selectedDesignation.includes(designation.key)}
          />
          {designation.value}
        </Menu.Item>
      ))}
    </Menu>
  );
  const shiftMenu = (
    <Menu onClick={handleShiftMenuClick}>
      {shift.map((shift) => (
        <Menu.Item className="checktext" key={shift.key}>
          <Checkbox
            className="mr-1"
            checked={selectedShift.includes(shift.key)}
          />
          {shift.value}
        </Menu.Item>
      ))}
    </Menu>
  );
  const [openDepartment, setOpenDepartment] = useState(false);

  const handleDepartmentOpenChange = (nextOpen, info) => {
    setOpenDepartment(nextOpen);
  };
  const [openDesignation, setOpenDesignation] = useState(false);
  const handleDesignationOpenChange = (nextOpen, info) => {
    console.log(nextOpen,'nextOpen')
    setOpenDesignation(nextOpen);
  };
  const [openAError, setOpenAError] = useState(false);
  const handleAErrorOpenChange = (nextOpen, info) => {
    setOpenAError(nextOpen);
  };
  const [openShift, setOpenShift] = useState(false);
  const handleShiftOpenChange = (nextOpen, info) => {
    setOpenShift(nextOpen);
  };
  const [open, setOpen] = useState(false);
  const handleOpenChange = (nextOpen, info) => {
    setOpen(nextOpen);
  };

  const clearFilter = () => {
      setSelectedDepartment(keys);
      setSelectedDesignation([]);
      setSelectedShift([])
      setSelectedLocation([])
  }
  const locationMenu = (
    <Menu onClick={handleLocationMenuClick}>
      {location.map((location) => (
        <Menu.Item className="checktext" key={location.key}>
          <Checkbox
            className="mr-1"
            checked={selectedLocation.includes(location.key)}
          />
          {location.value}
        </Menu.Item>
      ))}
    </Menu>
  );
  useEffect(() => {
    getStaffTodayList();
  }, [
    selectedDate,
    departmentsSelected,
    designationsSelected,
    locationSelected,
    shiftSelected,
    selectedDepartment,
    selectedDesignation,
    selectedLocation,
    selectedShift,
  ]);

  const getStaffTodayList = async () => {
    const token = localStorage.getItem("authToken");
    setIsLoadingSpinner(true);
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchAttendanceTodayView}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          attendanceDate: showSelectedDate,
          ...(selectedDepartment &&
            selectedDepartment.length > 0 && {
              department: selectedDepartment,
            }),
          ...(selectedDesignation &&
            selectedDesignation.length > 0 && {
              designation: selectedDesignation,
            }),
          ...(selectedLocation &&
            selectedLocation.length > 0 && { mainSite: selectedLocation }),
          ...(selectedShift &&
            selectedShift.length > 0 && { shift: selectedShift }),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setStaffData(data?.data);

        let allStaffDetails = [];

        data?.data?.staffAttendanceDetails?.forEach((department) => {
          allStaffDetails = allStaffDetails.concat(
            department.staffDetails.map((staff) => {
              let status = "";

              if (
                staff.isAbsent &&
                staff.attendanceDetail.length > 0 &&
                !staff.isStaffOut &&
                !staff.isStaffIn
              ) {
                status = "absent";
              } else if (!staff.isAbsent && staff.notInYet) {
                status = "notInYet";
              } else if (
                !staff.isAbsent &&
                staff.attendanceDetail.length > 0 &&
                staff.attendanceDetail[0].isStaffIn
              ) {
                status = "NotOutYet";
              } else if (
                !staff.isAbsent &&
                staff.attendanceDetail.length > 0 &&
                staff.attendanceDetail[0].isWeeklyOff &&
                !staff.attendanceDetail[0].isStaffOut
              ) {
                status = "WeekOff";
              } else if (
                !staff.isAbsent &&
                staff.attendanceDetail.length > 0 &&
                !staff.attendanceDetail[0].isWeeklyOff &&
                !staff.attendanceDetail[0].isStaffOut
              ) {
                status = "Absent";
              } else if (
                !staff.isAbsent &&
                staff.attendanceDetail.length > 0 &&
                staff.attendanceDetail[0].isWeeklyOff &&
                staff.attendanceDetail[0].isStaffOut
              ) {
                status = "Present";
              } else if (
                !staff.isAbsent &&
                staff.attendanceDetail.length > 0 &&
                !staff.attendanceDetail[0].isWeeklyOff &&
                staff.attendanceDetail[0].isStaffOut
              ) {
                status = "Present";
              } else if (staff.isAbsent && staff.attendanceDetail.length > 0) {
                status = "Absent";
              } else {
                status = "";
              }

              return {
                Name: `${staff.staffDetail.firstName} ${staff.staffDetail.lastName}`,
                Designation: staff.staffDetail.designationName,
                Department: department.departmentName,
                Status: status,
                Shift: capitalizeFirstLetter(staff?.shiftDetail?.shiftFullName),
                Locations: capitalizeFirstLetter(
                  staff?.mainSiteData
                    .map((item) => item?.locationName2)
                    .join(", ")
                ),
                Timings: `${formatTimeWithAMPM(
                  staff?.shiftDetail?.shiftStartTime
                )} - ${formatTimeWithAMPM(staff?.shiftDetail?.shiftEndTime)}`,
                CheckInTime:
                  staff.attendanceDetail[0]?.checkInTime !== undefined &&
                  formatTimeWithAMPM(staff.attendanceDetail[0]?.checkInTime) !==
                    undefined
                    ? formatTimeWithAMPM(staff.attendanceDetail[0]?.checkInTime)
                    : "---",
                CheckInLocation:
                  (staff?.isAbsent == false &&
                    staff?.attendanceDetail.length > 0 &&
                    staff?.attendanceDetail[0]?.isWeeklyOff == true &&
                    (staff?.attendanceDetail[0]?.isStaffIn == true ||
                      staff?.attendanceDetail[0]?.isStaffOut == true)) ||
                  (staff?.isAbsent == false &&
                    staff?.attendanceDetail.length > 0 &&
                    staff?.attendanceDetail[0]?.isWeeklyOff == false &&
                    (staff?.attendanceDetail[0]?.isStaffIn == true ||
                      staff?.attendanceDetail[0]?.isStaffOut == true))
                    ? staff.attendanceDetail[0]?.checkInLocation
                      ? capitalizeFirstLetter(
                          staff.attendanceDetail[0]?.checkInLocationDetail
                            ?.locationName2
                        )
                      : "Unknown Location"
                    : "--",
                CheckOutTime:
                  staff.attendanceDetail[0]?.checkOutTime !== undefined &&
                  formatTimeWithAMPM(
                    staff.attendanceDetail[0]?.checkOutTime
                  ) !== undefined
                    ? formatTimeWithAMPM(
                        staff.attendanceDetail[0]?.checkOutTime
                      )
                    : "---",
                CheckOutLocation:
                  (
                    staff?.attendanceDetail.length > 0 &&
                    staff?.attendanceDetail[0]?.isWeeklyOff == true &&
                    staff?.attendanceDetail[0]?.isStaffOut == true) ||
                  (
                    staff?.attendanceDetail.length > 0 &&
                    staff?.attendanceDetail[0]?.isWeeklyOff == false &&
                    staff?.attendanceDetail[0]?.isStaffOut == true)
                    ? staff.attendanceDetail[0]?.checkOutLocation
                      ? capitalizeFirstLetter(
                          staff.attendanceDetail[0]?.checkOutLocationDetail
                            ?.locationName2
                        )
                      : "Unknown Location"
                    : "--",

                OtTime: staff?.attendanceDetail[0]?.staffOtTime
                  ? formatTime(staff?.attendanceDetail[0]?.staffOtTime)
                  : "",
                LtTime: staff?.attendanceDetail[0]?.staffLtTime
                  ? formatTime(staff?.attendanceDetail[0]?.staffLtTime)
                  : "",
              };
            })
          );
        });
        setTodaysExportData(allStaffDetails);

        setIsLoadingSpinner(false);
      } else {
        const data = await response.json();
        setIsLoadingSpinner(false);
        // toast.error(data.errorMessage, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      }
    };

    await fetchData();
  };

  const showCalendar = () => {
    setCalendarVisible(true);
  };

  const hideCalendar = () => {
    setCalendarVisible(false);
  };

  const handleDateChange = (date, dateString) => {
    setshowSelectedDate(moment(date.$d).format("YYYY-MM-DD"));
    setSelectedDate(date);
    hideCalendar();
  };

  const handlePrevDay = () => {
    if (selectedDate) {
      const prevDay = selectedDate.clone().subtract(1, "day");
      const BoCreatedAt =
        userInfo?.userRole == "businessOwner"
          ? userInfo?.createdAt
          : userInfo?.boOwner?.createdAt;

      const limitDate = moment(BoCreatedAt);
      const limitDateMinusOneDay = limitDate.clone().subtract(1, "day");

      if (prevDay.isAfter(limitDateMinusOneDay)) {
        setSelectedDate(selectedDate.clone().subtract(1, "day"));
        setshowSelectedDate(
          moment(selectedDate.clone().subtract(1, "day").$d).format(
            "YYYY-MM-DD"
          )
        );
      } else {
        console.log("Cannot go beyond 2024-01-04");
      }
    }
  };

  const handleNextDay = () => {
    if (selectedDate) {
      const nextDay = selectedDate.clone().add(1, "day");
      const lastDayOfMonth = selectedDate.clone().endOf("month");

      if (nextDay.isBefore(dayjs())) {
        setSelectedDate(selectedDate.clone().add(1, "day"));
        setshowSelectedDate(
          moment(selectedDate.clone().add(1, "day").$d).format("YYYY-MM-DD")
        );
      }
    } else {
      console.log("Next day is in the next month");
    }
  };

  const calculateShiftDuration = (shiftStartTime, shiftEndTime) => {
    const milliseconds_in_a_day = 24 * 60 * 60 * 1000;
    let shiftDuration;

    if (shiftStartTime <= shiftEndTime) {
      shiftDuration = shiftEndTime - shiftStartTime;
    } else {
      shiftDuration = milliseconds_in_a_day - shiftStartTime + shiftEndTime;
    }

    return shiftDuration;
  };

  const [size, setSize] = useState("all");

  const onChange = (e) => {
    setSize(e.target.value);
    const selectedValue = e.target.value;
    setSelectedItems((prevFilterArray) => {
      if (selectedValue === "all") {
        return prevFilterArray.filter(
          (item) => item !== "isStaffIn" && item !== "isStaffOut"
        );
      } else {
        const newFilterArray = prevFilterArray.filter(
          (item) => item !== "isStaffIn" && item !== "isStaffOut"
        );
        return [...newFilterArray, selectedValue];
      }
    });
  };
  function formatTime(milliseconds) {
    if (milliseconds > 0) {
      const hours = Math.floor(milliseconds / 3600000);
      const minutes = Math.round((milliseconds % 3600000) / 60000);

      if (hours > 0) {
        return `${hours}:${minutes < 10 ? "0" : ""}${minutes} hr`;
      } else {
        return `${minutes} min`;
      }
    }
  }
  function formatTimeWithAMPM(milliseconds) {
    const hours = Math.floor(milliseconds / 3600000);
    const minutes = Math.round((milliseconds % 3600000) / 60000);

    const formattedHours = hours % 12 || 12;
    const ampm = hours >= 12 ? "PM" : "AM";

    return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
  }

  const disabledDate = (current) => {
    const BoCreatedAt =
      userInfo?.userRole == "businessOwner"
        ? userInfo?.createdAt
        : userInfo?.boOwner?.createdAt;
        const oneDayBeforeBoCreatedAt = moment(BoCreatedAt).subtract(1, 'days');
        
      
        return (
      current &&
      (current < moment(oneDayBeforeBoCreatedAt) || current > moment().endOf("day"))
    );
  };

  const showImage = (img) =>{
    console.log(img)
    setActiveImage(img);
    setOpenImageModal(true)
  }

  const getColumnDefs = () => {
    return [
      {
        headerName: "Profile",
        field: "profile",
        flex: 1,
        cellRenderer: (params) => {
          return (
            <>
              <div className="profile">
                <Row className="flex items-center flex-nowrap">
                  <img
                    className="!min-w-[47px] !mr-3"
                    style={{
                      width: "47px",
                      height: "47px",
                      borderRadius: "50%",
                    }}
                    src={params.data?.item?.staffDetail?.faceRegisterUrl || params.data?.item?.staffDetail?.logo || placeholder}
                    alt=""
                  />
                  <Col className="mt-1 nameMain">
                    <p className="font-sbold">
                      {capitalizeFirstLetter(
                        params.data.item?.staffDetail?.firstName
                      )}{" "}
                      {capitalizeFirstLetter(
                        params.data.item?.staffDetail?.lastName
                      )}
                      {params.data.item?.isAbsent == true &&
                      params.data.item?.attendanceDetail.length > 0 &&
                      params.data.item?.attendanceDetail[0]?.isStaffOut ==
                        false &&
                      params.data.item?.attendanceDetail[0]?.isStaffIn ==
                        false ? (
                        <span className="a ml-1 mr-1">A</span>
                      ) : params.data.item?.isAbsent == false &&
                        params.data.item?.notInYet == true ? (
                        <span></span>
                      ) : params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isStaffIn ==
                          true ? (
                        <span className="Ot ml-1 mr-1">CO</span>
                      ) : params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          true &&
                        params.data.item?.attendanceDetail[0]?.isStaffOut ==
                          false ? (
                        <span className="Ot ml-1 mr-1">WO</span>
                      ) : params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          false &&
                        params.data.item?.attendanceDetail[0]?.isStaffOut ==
                          false ? (
                        <span className="a ml-1 mr-1">A</span>
                      ) : params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          true &&
                        params.data.item?.attendanceDetail[0]?.isStaffOut ==
                          true ? (
                        <span className="p ml-1 mr-1">P</span>
                      ) : params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          false &&
                        params.data.item?.attendanceDetail[0]?.isStaffOut ==
                          true ? (
                        <>
                          <span className="p ml-1 mr-1">P</span>
                          {params.data.item?.attendanceDetail[0]
                            .isStaffHalfDay && (
                            <span className="h ml-1 mr-1">HD</span>
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isStaffOverTime && (
                            <span className="Ot ml-1 mr-1">OT</span>
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isStaffLessTime && (
                            <span className="Ot ml-1 mr-1">LT</span>
                          )}
                          {params.data.item?.attendanceDetail[0].isStaffEarly ||
                          params.data.item?.attendanceDetail[0].isStaffLate ? (
                            <span className="Ot ml-1 mr-1">WT</span>
                          ) : (
                            ""
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isWrongLocation && (
                            <span className="Ot ml-1 mr-1">WL</span>
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isStaffNotClockedOut && (
                            <span className="Ot ml-1 mr-1">CO</span>
                          )}
                        </>
                      ) : params.data.item?.isAbsent == true &&
                        params.data.item?.attendanceDetail.length > 0 ? (
                        <>
                          <span className="a ml-1 mr-1">A</span>
                          {params.data.item?.attendanceDetail[0]
                            .isStaffHalfDay && (
                            <span className="h ml-1 mr-1">HD</span>
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isStaffOverTime && (
                            <span className="Ot ml-1 mr-1">OT</span>
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isStaffLessTime && (
                            <span className="Ot ml-1 mr-1">LT</span>
                          )}
                          {params.data.item?.attendanceDetail[0].isStaffEarly ||
                          params.data.item?.attendanceDetail[0].isStaffLate ? (
                            <span className="Ot ml-1 mr-1">WT</span>
                          ) : (
                            ""
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isWrongLocation && (
                            <span className="Ot ml-1 mr-1">WL</span>
                          )}
                          {params.data.item?.attendanceDetail[0]
                            .isStaffNotClockedOut && (
                            <span className="Ot ml-1 mr-1">CO</span>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </p>
                    <p className="text-xs">
                      {capitalizeFirstLetter(
                        params.data.item?.staffDetail?.designationName
                      )}
                    </p>
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
      {
        headerName: "Planned",
        field: "planned",
        width: "350px",
        cellRenderer: (params) => {
          return (
            <>
              <div className="w-full">
                <Row className="w-full">
                  <Col
                    sm={24}
                    className="d-flex justify-content-between mt-1 nameMain w-full gap-4"
                  >
                    <div className="w-50p">
                      <p className="text-[13px] my-1">
                        <span className="text-[13px] text-[#4B8AEB] font-sbold">
                          Shift:
                        </span>{" "}
                        {capitalizeFirstLetter(
                          params.data.item?.shiftDetail?.shiftFullName
                        )}
                      </p>
                      <p className="text-[13px] my-1">
                        <span className="text-[13px] text-[#4B8AEB] font-sbold">
                          Location:
                        </span>{" "}
                        {capitalizeFirstLetter(
                          params.data?.item?.mainSiteData
                            .map((item) => item?.locationName2)
                            .join(", ")
                        )}
                      </p>
                    </div>
                    <div className="w-50p">
                      <p className="text-[13px] my-1">
                        <span className="text-[13px] text-[#4B8AEB] font-sbold">
                          Timings:
                        </span>{" "}
                        {formatTimeWithAMPM(
                          params.data.item?.shiftDetail?.shiftStartTime
                        )}{" "}
                        -{" "}
                        {formatTimeWithAMPM(
                          params.data.item?.shiftDetail?.shiftEndTime
                        )}
                      </p>
                      <p className="text-[13px] my-1">
                        <span className="text-[13px] text-[#4B8AEB] font-sbold">
                          Work hour:
                        </span>{" "}
                        {formatTime(
                          calculateShiftDuration(
                            params.data?.item?.shiftDetail?.shiftStartTime,
                            params.data?.item?.shiftDetail?.shiftEndTime
                          )
                        )}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
      {
        headerName: "Actual In",
        field: "actualIn",
        width: "240px",
        cellRenderer: (params) => {
          return (
            <>
              <div className="">
                <Row className="flex items-center flex-nowrap">
                <img
                    className="!min-w-[47px] !mr-3"
                    style={{
                      width: "47px",
                      height: "47px",
                      borderRadius: "50%",
                    }}
                    src={params?.data?.item?.attendanceDetail[0]?.checkInImage || placeholder}
                    alt=""
                    onClick={() => showImage(params?.data?.item?.attendanceDetail[0]?.checkInImage || placeholder)}
                  />
                  <Col className="mt-1 nameMain">
                    <p className="text-[13px]">
                      <span className="text-[13px] text-[#4B8AEB] font-sbold">
                        Clock In:
                      </span>{" "}
                      {params?.data?.item?.attendanceDetail[0]?.checkInTime !==
                        undefined &&
                      formatTimeWithAMPM(
                        params?.data?.item?.attendanceDetail[0]?.checkInTime
                      ) !== undefined
                        ? formatTimeWithAMPM(
                            params?.data?.item?.attendanceDetail[0]?.checkInTime
                          )
                        : "---"}
                    </p>
                    <p className="text-[13px]">
                      <span className="text-[13px] text-[#4B8AEB] font-sbold">
                        Location:
                      </span>{" "}
                      {(params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          true &&
                        (params.data.item?.attendanceDetail[0]?.isStaffIn ==
                          true ||
                          params.data.item?.attendanceDetail[0]?.isStaffOut ==
                            true)) ||
                      (
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          false &&
                        (params.data.item?.attendanceDetail[0]?.isStaffIn ==
                          true ||
                          params.data.item?.attendanceDetail[0]?.isStaffOut ==
                            true))
                        ? params.data.item.attendanceDetail[0]?.checkInLocation
                          ? capitalizeFirstLetter(
                              params.data.item.attendanceDetail[0]
                                ?.checkInLocationDetail?.locationName2
                            )
                          : "Unknown Location"
                        : "--"}
                    </p>
                    <p className="text-[13px]">
                      <span className="text-[13px] text-[#4B8AEB] font-sbold">
                        Device:
                      </span>{" "}
                      {params.data.item.attendanceDetail[0]?.checkInDevice
                        ? params.data.item.attendanceDetail[0]
                            ?.checkInDeviceDetail?.firstName
                        : "---"}
                    </p>
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
      {
        headerName: "Actual Out",
        field: "actualOut",
        flex: 1,
        width: "240px",
        cellRenderer: (params) => {
          return (
            <>
              <div className="">
              <Row className="flex items-center flex-nowrap">
                <img
                    className="!min-w-[47px] !mr-3"
                    style={{
                      width: "47px",
                      height: "47px",
                      borderRadius: "50%",
                    }}
                    src={params?.data?.item?.attendanceDetail[0]?.checkOutImage || placeholder}
                    alt=""
                    onClick={() => showImage(params?.data?.item?.attendanceDetail[0]?.checkOutImage || placeholder)}
                  />
                  <Col className="mt-1 nameMain">
                    <p className="text-[13px]">
                      <span className="text-[13px] text-[#4B8AEB] font-sbold">
                        Clock Out:
                      </span>{" "}
                      {params?.data?.item?.attendanceDetail[0]?.checkOutTime !==
                        undefined &&
                      formatTimeWithAMPM(
                        params?.data?.item?.attendanceDetail[0]?.checkOutTime
                      ) !== undefined
                        ? formatTimeWithAMPM(
                            params?.data?.item?.attendanceDetail[0]
                              ?.checkOutTime
                          )
                        : "---"}
                    </p>
                    <p className="text-[13px]">
                      <span className="text-[13px] text-[#4B8AEB] font-sbold">
                        Location:
                      </span>{" "}
                      {(params.data.item?.isAbsent == false &&
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          true &&
                        params.data.item?.attendanceDetail[0]?.isStaffOut ==
                          true) ||
                      (
                        params.data.item?.attendanceDetail.length > 0 &&
                        params.data.item?.attendanceDetail[0]?.isWeeklyOff ==
                          false &&
                        params.data.item?.attendanceDetail[0]?.isStaffOut ==
                          true)
                        ? params.data.item.attendanceDetail[0]?.checkOutLocation
                          ? capitalizeFirstLetter(
                              params.data.item.attendanceDetail[0]
                                ?.checkOutLocationDetail?.locationName2
                            )
                          : "Unknown Location"
                        : "--"}
                    </p>
                    <p className="text-[13px]">
                      <span className="text-[13px] text-[#4B8AEB] font-sbold">
                        Device:
                      </span>{" "}
                      {params.data.item.attendanceDetail[0]?.checkOutDevice
                        ? params.data.item.attendanceDetail[0]
                            ?.checkOutDeviceDetail?.firstName
                        : "---"}
                    </p>
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
      {
        headerName: "OT/LT",
        field: "other",
        flex: 1,
        cellRenderer: (params) => {
          return (
            <>
              <div className="">
                <Row>
                  <Col sm={18} className="mt-1 nameMain">
                    {params.data.item?.attendanceDetail[0]?.staffOtTime > 0 ? (
                      <p
                        style={{
                          color: "green",
                          fontSize: "12px",
                          fontWeight: "bolder",
                        }}
                      >
                        {formatTime(
                          params.data.item?.attendanceDetail[0]?.staffOtTime
                        )}
                      </p>
                    ) : (
                      <p
                        style={{
                          color: "red",
                          fontSize: "12px",
                          fontWeight: "bolder",
                        }}
                      >
                        {formatTime(
                          params.data.item?.attendanceDetail[0]?.staffLtTime
                        )}
                      </p>
                    )}
                    {params.data.item?.attendanceDetail[0]?.staffOtTime > 0 && (
                      <p>Over Time</p>
                    )}
                    {params.data.item?.attendanceDetail[0]?.staffLtTime > 0 && (
                      <p>Less Time</p>
                    )}
                    {(params.data.item?.attendanceDetail?.length == 0 ||
                      (params.data.item?.attendanceDetail[0]?.isStaffOverTime ==
                        false &&
                        params.data.item?.attendanceDetail[0]
                          ?.isStaffLessTime == false)) && <p>--</p>}
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
      {
        headerName: "Notes",
        field: "notes",
        width: "175px",
        cellRenderer: (params) => {
          return (
            <>
              <div className="">
                <Row>
                  <Col sm={18} className="mt-1 nameMain">
                    {params.data.item?.attendanceDetail[0]?.notes ? (
                      <p style={{fontSize:'12px'}}>
                        {params.data.item?.attendanceDetail[0]?.notes}
                      </p>

                      ) : (
                        "---"
                      )}
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
      {
        headerName: "Attachments",
        field: "attachments",
        width: "175px",
        cellRenderer: (params) => {
          return (
            <>
              <div className="">
                <Row>
                  <Col sm={18} className="mt-1 nameMain">
                    {params.data.item?.attendanceDetail[0]?.documents?.length >
                    0 ? (
                     
                        <img src={attachment} style={{width:"32px",height:"auto"}} onClick={() =>
                          attachmentsAndNotes(
                            params.data.item?.attendanceDetail[0]?.documents
                          )
                        }/>

                      ) : (
                        "---"
                      )}
                  </Col>
                </Row>
              </div>
            </>
          );
        },
      },
    ];
  };

  const getDepartmentRowData = (department) => {
    console.log(department.staffDetails,'department.staffDetails')
    if (selectedItems.length === 0) {
      return (
        department.staffDetails?.map((item, index) => ({
          key: index,
          item: item,
          profile: item?.staffDetail?.firstName,
        })) || []
      );
    }
    return (
      department.staffDetails
        ?.map((item, index) => {
          const shouldInclude = selectedItems.some((prop) => {
            if (prop === "isAbsent") {
              return item?.[prop] === true;
            } else {
              return item?.attendanceDetail[0]?.[prop] === true;
            }
          });

          if (shouldInclude) {
            return {
              key: index,
              item: item,
              profile: item?.staffDetail?.firstName,
            };
          }
          return null; // Skip this item if conditions are not met
        })
        .filter(Boolean) || []
    );
  };

  return (
    <div className="">
      {isLoadingSpinner && <Spinner />}
      <div>
        <Row className="gap-3">
          <Col>
            <div className="flex mr-1 gap-2">
              <div className="bg-[#E9F1FD] rounded-[9px] h-[52px] !px-2 text-[10px] flex justify-center items-center flex-col leading-none gap-1 min-w-[35px]">
                <p className="text-[17px] font-sbold !my-0 leading-none border-b border-[#C4CAD2] w-full !pb-1 flex items-center justify-center">
                  {staffData?.attendanceCount?.totalPresent}{" "}
                  <small className="text-[11px] !ml-1 text-[#71747A]">P</small>
                </p>
                <p className="!px-2">
                  {staffData?.attendanceCount?.totalIn} in |{" "}
                  {staffData?.attendanceCount?.totalOut} out
                </p>
              </div>
              <div className="bg-[#E9F1FD] rounded-[9px] h-[52px] !px-2 text-[10px] flex justify-center items-center flex-col leading-none gap-1 min-w-[35px]">
                <p className="text-[17px] font-sbold">
                  {staffData?.attendanceCount?.totalNotIn}
                </p>
                <p className="text-[11px]">Not in</p>
              </div>
              <div className="bg-[#E9F1FD] rounded-[9px] h-[52px] !px-2 text-[10px] flex justify-center items-center flex-col leading-none gap-1 min-w-[35px]">
                <p className="text-[17px] font-sbold">
                  {staffData?.attendanceCount?.totalOT}
                </p>
                <p className="text-[11px]">OT</p>
              </div>
              <div className="bg-[#E9F1FD] rounded-[9px] h-[52px] !px-2 text-[10px] flex justify-center items-center flex-col leading-none gap-1 min-w-[35px]">
                <p className="text-[17px] font-sbold">
                  {staffData?.attendanceCount?.totalOffs}
                </p>
                <p className="text-[11px]">Offs</p>
              </div>
              <div className="bg-[#E9F1FD] rounded-[9px] h-[52px] !px-2 text-[10px] flex justify-center items-center flex-col leading-none gap-1 min-w-[35px]">
                <p className="text-[17px] font-sbold">
                  {staffData?.attendanceCount?.totalLocationError}
                </p>
                <p className="text-[11px]">Loc. Err.</p>
              </div>
              <div className="bg-[#E9F1FD] rounded-[9px] h-[52px] !px-2 text-[10px] flex justify-center items-center flex-col leading-none gap-1 min-w-[35px]">
                <p className="text-[17px] font-sbold">
                  {staffData?.attendanceCount?.totalTimeError}
                </p>
                <p className="text-[11px]">Time Err</p>
              </div>
            </div>
          </Col>
          <Col className="bg-[#E9F1FD] rounded-[9px] min-h-[52px] flex items-center">
            <div className="flex justify-content-between filter flex-wrap items-center gap-2">
              <p className="text-sm font-sbold !ml-4 !mr-3">Filter</p>
              <Dropdown
                overlay={dept}
                trigger={["click"]}
                placement="bottom"
                onOpenChange={handleDepartmentOpenChange}
                open={openDepartment}
              >
                <Button className="bg-[#BAD2F8] !border-none !leading-none !pr-2 !outline-none">
                  <span className="!text-black text-sm font-sbold leading-none !flex items-center">
                    Department <FaAngleDown className="ml-1 text-xs" />
                  </span>
                </Button>
              </Dropdown>

              <Dropdown
                overlay={desigMenu}
                trigger={["click"]}
                placement="bottom"
                onOpenChange={handleDesignationOpenChange}
                open={openDesignation}
              >
                <Button className="bg-[#BAD2F8] border-none !leading-none !pr-2 !outline-none">
                  <span className="!text-black text-sm font-sbold leading-none !flex items-center">
                    Designation <FaAngleDown className="ml-1 text-xs" />
                  </span>
                </Button>
              </Dropdown>
              <Dropdown
                overlay={shiftMenu}
                trigger={["click"]}
                onOpenChange={handleShiftOpenChange}
                open={openShift}
                placement="bottom"
              >
                <Button className="bg-[#BAD2F8] border-none !leading-none !pr-2 !outline-none">
                  <span className="!text-black text-sm font-sbold leading-none !flex items-center">
                    Shift <FaAngleDown className="ml-1 text-xs" />
                  </span>
                </Button>
              </Dropdown>

              <Dropdown
                overlay={menu}
                trigger={["click"]}
                onOpenChange={handleAErrorOpenChange}
                open={openAError}
              >
                <Button
                  className="bg-[#BAD2F8] border-none !leading-none !pr-2 !outline-none"
                  onClick={(e) => e.preventDefault()}
                >
                  <span className="!text-black text-sm font-sbold leading-none !flex items-center">
                    Attendance Error <FaAngleDown className="ml-1 text-xs" />
                  </span>
                </Button>
              </Dropdown>
              <Dropdown
                trigger={["click"]}
                overlay={locationMenu}
                onOpenChange={handleOpenChange}
                open={open}
                placement="bottom"
              >
                <Button className="bg-[#BAD2F8] border-none !leading-none !pr-2 !outline-none">
                  <span className="!text-black text-sm font-sbold leading-none !flex items-center">
                    Location <FaAngleDown className="ml-1 text-xs" />
                  </span>
                </Button>
              </Dropdown>

              <Button onClick={() => clearFilter()} className="bg-[#BAD2F8] !border-none !leading-none !pr-2 !outline-none">
                <span className="!text-black text-sm font-sbold leading-none !flex items-center">
                  Clear Filter <FaXmark className="ml-1 text-xs" />
                </span>
              </Button>
            </div>
          </Col>
          <Col className="flex items-center">
            <Radio.Group
              className="bg-[#E9F1FD] rounded-[9px] !p-1"
              value={size}
              onChange={onChange}
            >
              <Radio.Button
                value="all"
                className="!py-[3px] font-normal !leading-none h-auto border-0 bg-transparent !px-4 !text-[15px] [&.ant-radio-button-wrapper-checked]:!bg-[#00305F] [&.ant-radio-button-wrapper-checked]:!text-white !rounded-full"
              >
                All
              </Radio.Button>
              <Radio.Button
                value="isStaffIn"
                className="!py-[3px] font-normal !leading-none h-auto border-0 bg-transparent !px-4 !text-[15px] [&.ant-radio-button-wrapper-checked]:!bg-[#00305F] [&.ant-radio-button-wrapper-checked]:!text-white !rounded-full"
              >
                In
              </Radio.Button>
              <Radio.Button
                value="isStaffOut"
                className="!py-[3px] font-normal !leading-none h-auto border-0 bg-transparent !px-4 !text-[15px] [&.ant-radio-button-wrapper-checked]:!bg-[#00305F] [&.ant-radio-button-wrapper-checked]:!text-white !rounded-full"
              >
                Out
              </Radio.Button>
            </Radio.Group>
          </Col>
          <Col className="ml-auto">
            <div className="icons mt-2">
              {staffData?.staffAttendanceDetails?.length > 0 && (
                <ExportToExcel
                  apiData={todaysExportData}
                  fileName={"TodaysAttendanceData"}
                />
              )}
              {isSearchVisible && (
                <input
                  type="text"
                  id="filter-text-box"
                  className="border-bottom h-[36.56px] !border-[#B7D0F7] outline-none ml-3"
                  placeholder="Search..."
                  onChange={onFilterTextBoxChanged}
                />
              )}
              <img src={SearchIcon} onClick={toggleSearchVisibility} className="text-xl ml-2 cursor-pointer"/>
            </div>
          </Col>
        </Row>
      </div>
      <Row className="flex justify-between items-center mt-2">
        <Col className="flex items-center !gap-4">
          <img src={CalendarIcon} onClick={showCalendar} className="h-[19px]" />

          <DatePicker
            suffixIcon={null}
            allowClear={false}
            value={selectedDate}
            onChange={handleDateChange}
            format="YYYY-MM-DD"
            style={{ width: "110px" }}
            className="calendarInput text-center border-none p-0"
            disabledDate={disabledDate}
            onBlur={hideCalendar} // Adjust the width as needed
            d
          />

          <LeftOutlined
            onClick={handlePrevDay}
            className="bg-[#E9F1FD] w-[22px] h-[22px] text-[12px] flex items-center justify-center text-[#14A4C2] rounded-[5px]"
          />
          <RightOutlined
            onClick={handleNextDay}
            className="bg-[#E9F1FD] w-[22px] h-[22px] text-[12px] flex items-center justify-center text-[#14A4C2] rounded-[5px]"
          />
        </Col>
        <Col className="todat-att flex gap-2">
          <div>
            <span className="p mr-1">P</span>
            <span className="to-con">Present</span>
          </div>
          <div>
            <span className="a mr-1">A</span>
            <span className="to-con">Absent</span>
          </div>
          <div>
            <span className="h mr-1">H</span>
            <span className="to-con">Half Day</span>
          </div>
          <div>
            <span className="Ot mr-1">OT</span>
            <span className="to-con">Overtime</span>
          </div>
          <div>
            <span className="Ot mr-1">LT</span>
            <span className="to-con">Less Time</span>
          </div>
          <div>
            <span className="Ot mr-1">WT</span>
            <span className="to-con">Wrong Time</span>
          </div>
          <div>
            <span className="Ot mr-1">WL</span>
            <span className="to-con">Wrong Location</span>
          </div>
          <div>
            <span className="Ot mr-1">CO</span>
            <span className="to-con">Not Clocked-out</span>
          </div>
        </Col>
      </Row>

      <div
        className="ag-theme-alpine text-base border-none font-proxima"
        style={{ marginTop: "10px" }}
      >
        {staffData?.staffAttendanceDetails.map((department, index) => (
          // selectedDepartment.includes(department.departmentId) &&
          <div key={index} className="department-table mb-3">
            <div className="my-1">
              <p className="text-lg text-[#4A9CED] font-sbold">
                {capitalizeFirstLetter(department.departmentName)} Department
              </p>
            </div>

            <AgGridReact
              className="fw600"
              gridOptions={gridOptions}
              columnDefs={getColumnDefs()}
              rowData={getDepartmentRowData(department)}
              domLayout="autoHeight"
              pagination={true}
              getRowHeight={() => 80}
              paginationPageSize={20}
              paginationPageSizeSelector={false}
              ref={(el) => (gridRef.current[index] = el)}
            />
          </div>
        ))}
        <div className="noDataFound">
          {staffData?.staffAttendanceDetails.length == 0 && (
            <span>No Data Found!</span>
          )}
        </div>
      </div>

      <AttachmentModal
        visible={openAttachmentModal}
        onOk={() => handleOk()}
        onCancel={handleCancel}
        attachments={attachments}
      />

    {openImageModal &&
      <ImageModal
        visible={openImageModal}
        onOk={() => setOpenImageModal(false)}
        onCancel={() => setOpenImageModal(false)}
        source={activeImage}
      />
    }
    </div>
  );
}

export default Today;
